if (!customElements.get('product-options')) {
  customElements.define(
    'product-options',
    // eslint-disable-next-line no-undef
    class ProductOptions extends window.BAO.CustomElement() {
      setupListeners () {
        super.setupListeners()

        if (!this.els.trigger || this.els.trigger.elements.length < 2) return

        this.handleTrigger = this.handleTrigger.bind(this)

        this.listeners.add(this, 'click', this.handleTrigger)

        this.listeners.add(this.els.select.element, 'change', this.handleChange.bind(this))
      }

      handleTrigger (event) {
        event.preventDefault()

        const trigger = event.target.closest(
          '[data-product-options-el="trigger"]',
        )
        if (!trigger) return

        trigger.setAttribute('aria-pressed', 'true')

        const optionIndex = trigger.dataset.index
        const optionValue = trigger.dataset.value

        const allIndexTriggerEls = [
          ...document.querySelectorAll(
            `${this.els.trigger.selector}[data-index="${optionIndex}"]`,
          ),
        ]

        allIndexTriggerEls.forEach(triggerEl => {
          triggerEl.setAttribute(
            'aria-pressed',
            (triggerEl === trigger).toString(),
          )
        })

        allIndexTriggerEls
          .filter(
            triggerEl => this.isQuickBuy(trigger) === this.isQuickBuy(triggerEl),
          )
          .forEach(triggerEl => {
            triggerEl.setAttribute(
              'aria-pressed',
              (triggerEl.dataset.value === optionValue).toString(),
            )
          })

        const allIndexSelectEls = [
          ...document.querySelectorAll(
            `${this.els.select.selector}[data-index="${optionIndex}"]`,
          ),
        ]

        allIndexSelectEls
          .filter(
            selectEl => this.isQuickBuy(trigger) === this.isQuickBuy(selectEl),
          )
          .forEach(selectEl => {
            selectEl.value = optionValue
            selectEl.dispatchEvent(new Event('change', { bubbles: true }))
          })
      }

      handleChange(event) {
        const selectIndex = event.target.dataset.index;
        const triggerEls = [...document.querySelectorAll(`${this.els.trigger.selector}[data-index="${selectIndex}"]`)]
        const parentElement = document.querySelector('.prd-FixedBar');
        const addToCartTriggers = [...document.querySelectorAll('[data-product-sticky-variant]')]

        addToCartTriggers.forEach((trigger) => {
          trigger.textContent = ` - ${event.target.dataset.name} ${event.target.value}`
        })

        triggerEls.forEach((triggerEl) => {
          triggerEl.setAttribute('aria-pressed', (triggerEl.dataset.value === event.target.value).toString())
        })

        parentElement.classList.add('prd-FixedBar-Selected');
      }

      isQuickBuy (element) {
        return !!element.closest('[data-section="product-quickbuy"]')
      }
    },
  )
}
